import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { from, groupBy, mergeMap, toArray, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  constructor(private http: HttpClient) {}

  public getOpportunitiesByCategory = (startDate: string, endDate: string) =>
    this.http.get<any>(
      `https://js.devexpress.com/Demos/RwaService/api/Analytics/OpportunitiesByCategory/${startDate}/${endDate}`
    );

  public getSalesByCategory = (startDate: string, endDate: string) =>
    this.http.get<any>(
      `https://js.devexpress.com/Demos/RwaService/api/Analytics/SalesByCategory/${startDate}/${endDate}`
    );

  public getSales = (startDate: string, endDate: string) =>
    this.http.get<any[]>(
      `https://js.devexpress.com/Demos/RwaService/api/Analytics/Sales/${startDate}/${endDate}`
    );

  public getSalesByStateAndCity = (startDate: string, endDate: string) =>
    this.http.get(
      `https://js.devexpress.com/Demos/RwaService/api/Analytics/SalesByStateAndCity/${startDate}/${endDate}`
    );

  public getSalesByState = (data: any) => {
    let dataByState;
    from(data)
      .pipe(
        groupBy((s: any) => s.stateName),
        mergeMap((group) => group.pipe(toArray())),
        map((val) => {
          let total = 0;
          let percentage = 0;
          val.forEach((v) => {
            total = total + v.total;
            percentage = percentage + v.percentage;
          });

          return {
            stateName: val[0].stateName,
            stateCoords: val[0].stateCoords,
            total,
            percentage,
          };
        }),
        toArray()
      )
      .subscribe((data) => {
        dataByState = data;
      });

    return dataByState;
  };
}
